"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBackslashEscaped = getBackslashEscaped;
function getBackslashEscaped(_ref) {
  var input = _ref.input;
  return extract(input);
}
function extract(str) {
  return str.replace(/\\n/g, "");
}